import TrailerIconSVG from "@/public/TrailerButtonMark1.svg";
import { Filmomtale, Trailer } from '@filmweb/sanity-types';
import TrailerPlayer from 'components/film/TrailerPlayer';
import { useState } from 'react';
import styled from 'styled-components';

//#region [Styles]
const STrailerPlayButton = styled.button`
	position: absolute;
	color: #fff;
	width: 5%;
	min-width: 100px;
	padding: 0;
	margin: 0;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: none;
	border: none;
	cursor: pointer;

	svg {
		width: 100%;
	}
`;

const STrailerBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;

	@media screen and (max-width: 640px) {
		height: 100vh;
		z-index: 9001;
	}

	&::before {
		content: "";
		background: #000000;
		background: rgba(0, 0, 0, 0.9);

		position: absolute;
		width: 100vw;
		min-height: 100%;
		top: 0;
		left: calc(-50vw + 50%);
		z-index: 0;
	}
`;

//#endregion

//#region [Props]
type TrailerContainerProps = {
	filmomtale: Filmomtale;
};
//#endregion

//#region [Component]
export default function TrailerContainer({ filmomtale }: TrailerContainerProps) {
	const [isShowingTrailer, setIsShowingTrailer] = useState(false);

	const trailer = filmomtale.trailers?.[0];

	if (!trailer) {
		return null;
	}

	return <>
		{!isShowingTrailer && <STrailerPlayButton onClick={() => setIsShowingTrailer(true)} title="Spill av trailer" type="button">
			<TrailerIconSVG />
		</STrailerPlayButton>}

		{isShowingTrailer && <STrailerBackground onClick={() => setIsShowingTrailer(false)}>
			<TrailerPlayer clipId={(trailer as Trailer).videoId} trailerClose={() => setIsShowingTrailer(false)}/>
		</STrailerBackground>}
	</>

}
//#endregion